import { Controller, useFormContext } from "react-hook-form"
import { DepreciationType } from "../../utils"
import { Button, Label, NumberInput, Select } from "components"
import { FormDataContext } from "../../context"
import { useContext, useEffect } from "react"

export function FormDepreciation(props: { onSubmit: () => void }) {
    const { formState } = useFormContext<DepreciationType>()
    const { dataAsset } = useContext(FormDataContext)
    

    return (
        <section className="py-5 px-6">
            <div className="w-full flex-col flex gap-8">
                <DepreciationDetail />
            </div>
            <div className="mt-10 flex justify-end">
                <Button
                    type="button"
                    color="primary"
                    onClick={props.onSubmit}
                    loading={formState.isSubmitting ? "true" : undefined}
                >
                    {dataAsset?.asset_infodepreciation_id ? "Update" : "Save"}
                </Button>
            </div>
        </section>
    )
}

function DepreciationDetail() {
    const { control, setValue } = useFormContext<DepreciationType>()
    const { dataAsset } = useContext(FormDataContext)

    const depreciationPeriod = [
        { value: "1", label: "Month" },
        { value: "2", label: "Year" },
    ]

    const depreciationMthode = [
        { value: "1", label: "Straight Line" },
    ]

    // const periode = watch("depreciation_period") 

    const constanta = 1;
    
    const netValueBooks = Number(dataAsset?.acquisition_cost!) - Number(dataAsset?.depreciation_accumulation);

    useEffect(() => {
        const expenseDepreciation = Math.round(Number(dataAsset?.acquisition_cost ?? 0) / (Number(dataAsset?.depreciation_duration ?? 0) * constanta))
        const depreciationRate = (Number(expenseDepreciation)) / (Number(dataAsset?.acquisition_cost!)) * 100

        setValue("depreciation_expences", expenseDepreciation)
        setValue("depreciation_rate", Number(depreciationRate.toFixed(1)))
        // eslint-disable-next-line
    }, [dataAsset, constanta])


    return (
        <div>
            <div className="font-bold mb-4 bg-slate-400 p-2 dark:text-white rounded-sm">DEPRECIATION DETAIL :</div>
            <div className="flex flex-col gap-2">
                <div className="flex gap-2">
                    <Label className="w-[250px]">DEPRECIATION PERIOD</Label>
                    <Controller
                        control={control}
                        name="depreciation_period"
                        render={({ field, fieldState }) => (
                            <Select
                                placeholder="Select depreciation period..."
                                {...field}
                                error={fieldState.error?.message}
                                onChange={e => field.onChange(e?.value)}
                                options={depreciationPeriod}
                                value={depreciationPeriod.find(item => item.value === field.value?.toString())}
                                isDisabled={Number(dataAsset?.depreciation_accumulation) !== 0}
                            />
                        )}
                    />
                </div>

                <div className="flex gap-2">
                    <Label className="w-[250px]">DEPRECIATION METHOD</Label>
                    <Controller
                        control={control}
                        name="depreciation_methode"
                        render={({ field, fieldState }) => (
                            <Select
                                placeholder="Select depreciation methode..."
                                {...field}
                                error={fieldState.error?.message}
                                onChange={e => field.onChange(e?.value)}
                                options={depreciationMthode}
                                value={depreciationMthode.find(item => item.value === field.value?.toString())}
                                isDisabled={Number(dataAsset?.depreciation_accumulation) !== 0}
                            />
                        )}
                    />
                </div>

                <div className="flex gap-2">
                    <Label className="w-[250px]">EXPENSE DEPRECIATION</Label>
                    <div className="flex-grow">
                        <Controller
                            control={control}
                            name="depreciation_expences"
                            render={({ field }) => (
                                <NumberInput
                                    disabled
                                    className="flex-grow"
                                    value={field.value}
                                    decimalScale={2}
                                />
                            )}
                        />
                    </div>
                </div>

                <div className="flex gap-2">
                    <Label className="w-[250px]">DEPRECIATION RATE (%)</Label>
                    <div className="flex-grow">
                        <Controller
                            control={control}
                            name="depreciation_rate"
                            render={({ field }) => (
                                <NumberInput
                                    disabled
                                    className="flex-grow"
                                    value={field.value}
                                    decimalScale={3}
                                />
                            )}
                        />
                    </div>
                </div>

                <div className="flex gap-2">
                    <Label className="w-[250px]">ACCUMULATED DEPRECIATION</Label>
                    <div className="flex-grow">
                        <NumberInput
                            disabled
                            className="flex-grow"
                            value={dataAsset?.depreciation_accumulation}
                        />
                    </div>
                </div>

                <div className="flex gap-2">
                    <Label className="w-[250px]">NET BOOK VALUE</Label>
                    <div className="flex-grow">
                        <NumberInput
                            disabled
                            className="flex-grow"
                            value={netValueBooks}
                            decimalScale={2}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}
